interface BoxTruckMapLegendProps {
    showLoads: boolean
}

export const BoxTruckMapLegend = ({ showLoads }: BoxTruckMapLegendProps) => {
    return (
        <div className="pointer-events-none absolute bottom-4 left-4 z-10 flex max-w-[calc(100%-2rem)] flex-wrap items-center gap-x-3 gap-y-1 rounded-3xl bg-surface px-3 py-2 text-xs text-foreground-muted shadow-overlay">
            {showLoads && (
                <span className="inline-flex items-center gap-1.5">
                    <span className="h-3 w-4 rounded-sm bg-accent" /> State loads
                </span>
            )}
            <span className="inline-flex items-center gap-1.5">
                <span className="flex h-4 min-w-4 items-center justify-center rounded-full bg-accent px-1 text-[9px] text-accent-foreground">#</span> Driver
                group
            </span>
            <span className="inline-flex items-center gap-1.5">
                <span className="h-2.5 w-2.5 rounded-full bg-success" /> Verified
            </span>
            <span className="inline-flex items-center gap-1.5">
                <span className="h-2.5 w-2.5 rounded-full bg-warning" /> Unverified
            </span>
        </div>
    )
}
